// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './IconButton';



// WEBPACK FOOTER //
// ./components/IconButton/index.js